import { render, staticRenderFns } from "./dbusiness.vue?vue&type=template&id=8d8fa0da&scoped=true&"
import script from "./dbusiness.vue?vue&type=script&lang=js&"
export * from "./dbusiness.vue?vue&type=script&lang=js&"
import style0 from "./dbusiness.vue?vue&type=style&index=0&id=8d8fa0da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8fa0da",
  null
  
)

export default component.exports